import axios from "axios";

export const state = {
    paymentoptions: [],
};

export const getters = {
    paymentoptions: state => state.paymentoptions,
};

export const mutations = {
    setMethods(paymentoptions, newValue) {
        state.paymentoptions = newValue
    },
};

export const actions = {
    fetchPaymentoptions({ commit }) {
        axios.get('/methods').then(res => {
            commit('setMethods', res.data.methods)
        })
    },
};
